import React from "react";
import { cn } from "src/utils/cn";

export type OptionContainerProps = {
  label: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

export function OptionContainer({
  label,
  children,
  className = "",
  disabled = false,
}: OptionContainerProps) {
  return (
    <div className={cn("flex items-center justify-between gap-4", className)}>
      <div
        className={cn(
          "text-sm text-gray-700 transition-opacity",
          disabled ? "opacity-50" : "opacity-100"
        )}
      >
        {label}
      </div>
      <div
        className={cn(
          "transition-opacity",
          disabled ? "opacity-50" : "opacity-100"
        )}
      >
        {children}
      </div>
    </div>
  );
}
